export enum CurrencyType {
  USD = 'USD',
  COP = 'COP',
}

export interface CurrencyFormat {
  currencyCode: string;
  currencySymbol: string;
  currencyFormat: string;
}

export const DEFAULT_CURRENCY_FORMAT: CurrencyFormat = {
  currencyCode: 'COP',
  currencySymbol: '$ ',
  currencyFormat: '2.0-0',
};

export const SUPPORTED_CURRENCY_FORMATS: CurrencyFormat[] = [
  {
    currencyCode: CurrencyType.USD,
    currencySymbol: 'USD ',
    currencyFormat: '1.2-2',
  },
  DEFAULT_CURRENCY_FORMAT,
];

/**
 * Returns currency format for the site's primary currency.
 * Unknown or empty values fall back to {@link DEFAULT_CURRENCY_FORMAT}.
 */
export function getCurrencyFormatByPrimary(
  primaryCurrencyType: string
): CurrencyFormat {
  const pct =
    primaryCurrencyType?.trim() || DEFAULT_CURRENCY_FORMAT.currencyCode;
  const found = SUPPORTED_CURRENCY_FORMATS.find(
    (f) => f.currencyCode === pct
  );
  return found ?? DEFAULT_CURRENCY_FORMAT;
}
